// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'


export const firebaseConfig = {
  apiKey: "AIzaSyDIsOmdxsWdcrRs0Umdz15k36V2aMH9ZT8",
  authDomain: "surveyneuro-b6f18.firebaseapp.com",
  projectId: "surveyneuro-b6f18",
  storageBucket: "surveyneuro-b6f18.firebasestorage.app",
  messagingSenderId: "59854781284",
  appId: "1:59854781284:web:ca3e083666d93cc8639871",
  measurementId: "G-YG1QWR5HCJ"
};
  


const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app) // <-- Storage referansı
